import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

export interface FormLabelProps {
  label: ReactNode;
  required?: boolean | 'asterisk';
  htmlFor?: string;
  side?: boolean;
}

const FormLabel = ({
  label,
  required,
  htmlFor,
  side = false,
}: FormLabelProps) => {
  const t = useTranslations('common.form');

  return (
    <div
      className={clsx(
        'flex w-full items-center leading-[1.125]',
        !side && 'mb-xxs',
      )}
    >
      <div className="flex w-full font-semibold">
        <label
          htmlFor={htmlFor}
          className="flex w-full items-center justify-between"
        >
          <span className="w-full">
            {label}
            {required === 'asterisk' && ' *'}
          </span>
        </label>
      </div>
      {required === true && (
        <div className="ml-auto text-muted">{t('obligatory.required')}</div>
      )}
    </div>
  );
};

export default FormLabel;
